import React from "react";
import { IconButton } from "@mui/material";
import { ArrowLeft } from "lucide-react";

/**
 * Optional app-bar back control; renders nothing when `backAction` is missing.
 * @param {object} props
 * @param {{ onClick: () => void, icon?: import("react").ReactNode, ariaLabel?: string } | null | undefined} props.backAction
 * @param {import("@mui/material").SxProps<import("@mui/material").Theme>} [props.sx] - Merged into the `IconButton` `sx`.
 * @returns {import("react").JSX.Element | null}
 */
export default function BackButton({ backAction, sx }) {
  if (!backAction) return null;
  return (
    <IconButton onClick={backAction.onClick} aria-label={backAction.ariaLabel ?? "Go back"} sx={sx}>
      {backAction.icon ?? <ArrowLeft size={20} color="#9D6AC4" />}
    </IconButton>
  );
}
